(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('SalesFunnelFactory', SalesFunnelFactory);

    /** @ngInject */
    function SalesFunnelFactory($resource) {
        var resourceUrl = '';
        return $resource(resourceUrl, {}, {
            'getCardWall': {
                method: 'GET',
                url: 'admin/api/salesFunnelCardWall',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'addStage': {
                method: 'POST',
                url: 'admin/api/salesFunnelStage',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateStage': {
                method: 'PUT',
                url: 'admin/api/salesFunnelStage/:stageId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteStage': {
                method: 'DELETE',
                url: 'admin/api/salesFunnelStage/:stageId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getNegotiation': {
                method: 'GET',
                url: 'admin/api/negotiation/:negotiationId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'addNegotiation': {
                method: 'POST',
                url: 'admin/api/negotiation',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateNegotiation': {
                method: 'PUT',
                url: 'admin/api/negotiation/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateNegotiationStage': {
                method: 'PUT',
                url: 'admin/api/negotiation/:id/stage',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteNegotiation': {
                method: 'DELETE',
                url: 'admin/api/negotiation/:negotiationId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'loadNegotiations': {
                method: 'GET',
                url: 'admin/api/negotiation/next?stageId=:stageId&offset=:offset',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
